import { LoyaltyOfferCard, LoyaltyOffersModalContainer } from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const LoyaltyOffers = {
  Modal: LoyaltyOffersModalContainer,
  Card: LoyaltyOfferCard,
};
